module.exports = __webpack_public_path__ + "static/media/129-wallet.a63bf01b.svg";